/* FD Gift Selector 2.3 — Default Puck Press, disabled buttons + bump if cleared */
(function(){
  'use strict';

  const SEL = '#fd-gift-selector';
  const el = document.querySelector(SEL);
  if (!el) return;

  const cards = el.querySelectorAll('.fdg2-card');
  const summary = el.querySelector('#fdg2-summary');
  const confirm = el.querySelector('#fdg2-confirm');
  const confirmText = el.querySelector('#fdg2-confirm-text');

  const selections = { gave: '', 'størrelse': '', farge: '', type: '' };

  function getForm() {
    return document.querySelector('product-form form') ||
           document.querySelector('form[action*="/cart/add"]:not(.installment)');
  }

  function setLocked(locked) {
    document.body.classList.toggle('fdg2-locked', locked);
    document.querySelectorAll('button[name="add"]').forEach(btn => {
      if (locked) {
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('disabled');
        btn.setAttribute('aria-disabled', 'false');
      }
    });
  }

  function bump() {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    summary.textContent = 'Du må velge en gratis gave før du kan kjøpe';
    summary.style.color = '#c0392b';
    summary.style.fontWeight = '600';
    el.classList.remove('fdg2--bump');
    void el.offsetWidth; // restart animation
    el.classList.add('fdg2--bump');
  }
  window.__fdg2Bump = bump;

  function activateCard(card) {
    const gift = card.dataset.gift;
    const value = card.dataset.value;
    const hasVariants = card.dataset.hasVariants === 'true';

    cards.forEach(c => c.classList.remove('fdg2-card--active'));
    card.classList.add('fdg2-card--active');
    selections.gave = value;
    selections['størrelse'] = '';
    selections.farge = '';
    selections.type = '';

    el.querySelectorAll('.fdg2-variants').forEach(v => {
      v.hidden = true;
      v.querySelectorAll('.fdg2-vbtn').forEach(b => b.classList.remove('fdg2-vbtn--active'));
    });

    if (hasVariants) {
      const panel = el.querySelector('#fdg2-variants-' + gift);
      if (panel) {
        panel.hidden = false;
        panel.querySelectorAll('.fdg2-vbtns').forEach(group => {
          const first = group.querySelector('.fdg2-vbtn');
          if (first) {
            first.classList.add('fdg2-vbtn--active');
            const prop = group.dataset.prop;
            selections[prop] = first.dataset.value;
          }
        });
      }
    }

    summary.style.color = '';
    summary.style.fontWeight = '';
    setLocked(false);
    updateFormInputs();
    updateConfirmBar();
  }

  cards.forEach(card => {
    card.addEventListener('click', () => activateCard(card));
  });

  el.querySelectorAll('.fdg2-vbtn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const group = btn.closest('.fdg2-vbtns');
      const prop = group.dataset.prop;
      group.querySelectorAll('.fdg2-vbtn').forEach(b => b.classList.remove('fdg2-vbtn--active'));
      btn.classList.add('fdg2-vbtn--active');
      selections[prop] = btn.dataset.value;
      updateFormInputs();
      updateConfirmBar();
    });
  });

  function updateFormInputs() {
    const form = getForm();
    if (!form) return;
    setHidden(form, 'properties[Gratis gave]', selections.gave);
    setHidden(form, 'properties[Gave Størrelse]', selections['størrelse']);
    setHidden(form, 'properties[Gave Farge]', selections.farge);
    setHidden(form, 'properties[Gave Type]', selections.type);
  }

  function setHidden(form, name, value) {
    let input = form.querySelector('input[name="' + name + '"]');
    if (value) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = value;
    } else if (input) {
      input.remove();
    }
  }

  function updateConfirmBar() {
    if (!selections.gave) {
      confirm.hidden = true;
      return;
    }
    let text = selections.gave;
    const extras = [];
    if (selections['størrelse']) extras.push(selections['størrelse']);
    if (selections.farge) extras.push(selections.farge);
    if (selections.type) extras.push(selections.type);
    if (extras.length) text += ' — ' + extras.join(', ');

    summary.textContent = 'Valgt: ' + text;
    confirmText.textContent = text + ' legges til i bestillingen';
    confirm.hidden = false;
  }

  // ── Activate default card (Puck Press) ──
  const defaultCard = el.querySelector('.fdg2-card[data-default="true"]') ||
                      el.querySelector('.fdg2-card[data-gift="puckpress"]');
  if (defaultCard) {
    activateCard(defaultCard);
  }

  // ── Defense-in-depth: formdata + submit listener ──
  function attachFormGuards(form) {
    if (!form || form.__fdg2Guarded) return;
    form.__fdg2Guarded = true;

    form.addEventListener('formdata', (e) => {
      if (selections.gave) {
        e.formData.set('properties[Gratis gave]', selections.gave);
        if (selections['størrelse']) e.formData.set('properties[Gave Størrelse]', selections['størrelse']);
        if (selections.farge) e.formData.set('properties[Gave Farge]', selections.farge);
        if (selections.type) e.formData.set('properties[Gave Type]', selections.type);
      }
    });

    form.addEventListener('submit', (e) => {
      if (!selections.gave) {
        e.preventDefault();
        e.stopImmediatePropagation();
        bump();
        return false;
      }
    }, true);
  }
  attachFormGuards(getForm());

  // Watch for form re-renders (variant change in Refresh can swap product-form)
  const formObs = new MutationObserver(() => {
    attachFormGuards(getForm());
    if (selections.gave) updateFormInputs();
  });
  formObs.observe(document.body, { childList: true, subtree: true });
})();
